import React from "react";
import styles from "./ripple.module.css";

function Ripple() {
  return <div className={styles.ldsripple}></div>;
}

export default Ripple;
